var link_viewer_default = {
  "fontElementMap": "GxuYW",
  "link": "_8d1uM",
  "linkInEditor": "KH8PN",
  "linkInViewer": "q2YPK",
  "toolbarUrlContainer": "_1nKFa",
  "toolbarUrl": "Hat6A",
  "toolbarUrlAnchor": "prysT"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
